if (!customElements.get("upsell-products-custom")) {
  customElements.define(
    "upsell-products-custom",
    class UpsellProductCustom extends HTMLElement {
      constructor() {
        super();
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        var tags = $(".included-component-wrapper").data("tags");
        var artags = tags.split(",");
        var arinitial = [];
        var year = "";
        var make = "";
        var model = "";
        for (let i = 0; i < artags.length; i++) {
          var tag = artags[i].split("_");
          if (tag[0] == "YEAR") {
            year = artags[i];
          }
          if (tag[0] == "MAKE") {
            make = artags[i];
          }
          if (tag[0] == "MODEL") {
            model = artags[i];
          }
        }
         
        this.loadProductData(year, make, model);
      }
      loadProductData(year, make, model) {
        var yearc = year.replace(".", "").toLowerCase();
        var makec = make.replace(".", "").toLowerCase();
        makec = makec.replace("/", "-");
        var modelc = model.replace(".", "").toLowerCase();
        var smodelc = modelc.split("/").join("-");
        var strpartn =
          yearc.split(" ").join("-") +
          "+" +
          makec.split(" ").join("-") +
          "+" +
          smodelc.split(" ").join("-");
        fetch("/collections/all/" + strpartn)
          .then((response) => response.text())
          .then((responseText) => {
            var swiper;
            const html = responseText;
            var elem = new DOMParser()
              .parseFromString(html, "text/html")
              .getElementsByClassName("after-reset")[0];
            if (elem) {
              var htmlmake = new DOMParser()
                .parseFromString(html, "text/html")
                .getElementsByClassName("after-reset")[0].innerHTML;

              $(".upsell-products-container").html(htmlmake);
              $(".upsell-products .category-products-all").hide();
              $(
                '.upsell-products .category-products-all[data-handle="' +
                  $(".upsell-products .featured-swatch").eq(0).data("handle") +
                  '"]'
              ).css("display", "flex");

              $(".featured-swatch").click(function () {
                $(".featured-swatch").removeClass("active");
                $(this).addClass("active");
                $(".category-products-all").hide();
                $(
                  '.category-products-all[data-handle="' +
                    $(this).data("handle") +
                    '"]'
                ).css("display", "flex");
              });
              $(".action-button-wrapper .custom-product-item-button").html(
                "Add To Cart "
              );
              $(
                '.custom-product-item[data-productid="' +
                  $(".upsell-products").data("productid") +
                  '"]'
              ).remove();
              $(".product-list .category-products-all").each(function () {
                if ($(this).find(".custom-product-item").length == 0) {
                  $(
                    '.featured-swatch[data-handle="' +
                      $(this).data("handle") +
                      '"]'
                  ).css("display", "none");
                }
              });

              $(".currenttagfit").html(
                yearc.split("_")[1].toUpperCase() +
                  " " +
                  makec.split("_")[1].toUpperCase() +
                  " " +
                  modelc.split("_")[1].toUpperCase()
              );

              $(".action-button-wrapper a").removeAttr("href");

              setTimeout(function () {
                $(".action-button-wrapper .custom-product-item-button")
                  .unbind()
                  .click(function (params) {
                    const config = fetchConfig("javascript");
                    config.headers["X-Requested-With"] = "XMLHttpRequest";
                    delete config.headers["Content-Type"];
                    const formData = new FormData();
                    if (this.cart) {
                      formData.append(
                        "sections",
                        this.cart
                          .getSectionsToRender()
                          .map((section) => section.id)
                      );
                      formData.append("sections_url", window.location.pathname);
                      this.cart.setActiveElement(document.activeElement);
                    }
                    formData.append(
                      "id",
                      $(this).parents(".custom-product-item").data("productid")
                    );
                    formData.append("quantity", 1);
                    config.body = formData;

                    var this2 = this;
                    $(
                      this
                    ).html(`<div class="loading-overlay__spinner" bis_skin_checked="1">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle style="stroke:white;" class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>`);

                    fetch(`${routes.cart_add_url}`, config)
                      .then((response) => response.json())
                      .then((response) => {
                        if (response.status) {
                          $(this2).after(
                            `<div class="error-message-upsell" style="font-weight:500;margin-top:10px;line-height:1.6;color:red;font-size:12px;text-align:center;">${response.description}</div>`
                          );
                          return;
                        } else if (!this.cart) {
                          window.location = window.routes.cart_url;
                          return;
                        }

                        const quickAddModal =
                          document.closest("quick-add-modal");
                        if (quickAddModal) {
                          document.body.addEventListener(
                            "modalClosed",
                            () => {
                              setTimeout(() => {
                                this.cart.renderContents(response);
                              });
                            },
                            { once: true }
                          );
                          quickAddModal.hide(true);
                        } else {
                          this.cart.renderContents(response);
                        }
                      })
                      .catch((e) => {
                        console.error(e);
                      })
                      .finally(() => {
                        $(this2).html("Add To Cart");
                      });
                  });
              }, 500);

              $(".upsell-products-container .custom-product-item").addClass(
                "swiper-slide"
              );
              $(".upsell-products-container .category-products-all").addClass(
                "swiper-wrapper"
              );
              $(
                ".upsell-products-container .custom-product-item-container"
              ).addClass("swiper");
              $(".upsell-products-container .category-products-all").each(
                function () {
                  var htmlin = $(this).html();
                  $(this).html('<div class="swiper-wrapper"></div>');
                  $(this).find(".swiper-wrapper").append(htmlin);
                  $(this)
                    .find(".swiper-wrapper")
                    .after(
                      '<span class="swiper-button-prev swiper-button-prev-upsell"></span>'
                    );
                  $(this)
                    .find(".swiper-wrapper")
                    .after(
                      '<span class="swiper-button-next swiper-button-next-upsell"></span>'
                    );
                  $(this)
                    .find(".swiper-wrapper")
                    .after(
                      '<span class="swiper-pagination swiper-pagination-upsell"></span>'
                    );
                }
              );

              var swiper = new Swiper(
                ".upsell-products-container .category-products-all",
                {
                  slidesPerView: 1,
                  spaceBetween: 30,
                  breakpoints: {
                    640: {
                      slidesPerView: 1,
                      spaceBetween: 30,
                    },
                    990: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    1401: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                  },
                  navigation: {
                    nextEl: ".swiper-button-next-upsell",
                    prevEl: ".swiper-button-prev-upsell",
                  },
                  pagination: {
                    el: ".swiper-pagination-upsell",
                  },
                }
              );
            } else {
              this.loadProductData();
            }
          });
      }
    }
  );
}
